<script lang="ts">
	const { awinId }: { awinId?: string } = $props();
</script>

<svelte:head>
	{#if awinId}
		{@html `
		<script type="text/javascript">
			var AWIN = AWIN || {};
			AWIN.Tracking = AWIN.Tracking || {};
			AWIN.Tracking.AdvertiserConsent = false;

			window.addEventListener('DOMContentLoaded', () => {
				__tcfapi("addEventListener", 2, function (tcData, success) {
					if (success) {
                        // @TODO: Retrieve id with config
						const vendorConsent = tcData.vendor.consents[907];

						// Vendor consent can be undefined
						AWIN.Tracking.Consent.setAdvertiserConsentStatus(vendorConsent === true);
					}
				});
			});
		</script>
		`}
		<script defer src={`https://www.dwin1.com/${awinId}.js`} type="text/javascript"></script>
	{/if}
</svelte:head>
